const bookingData = [
  {
    id: 1,
    name: "John Doe",
    email: "john@example.com",
    package: "basic",
    date: "2024-08-01",
  },
  {
    id: 2,
    name: "Jane Smith",
    email: "jane@example.com",
    package: "intermediate",
    date: "2024-08-02",
  },
  {
    id: 3,
    name: "Sam Wilson",
    email: "sam@example.com",
    package: "vip",
    date: "2024-08-03",
  },
  {
    id: 4,
    name: "John Doe",
    email: "john@example.com",
    package: "basic",
    date: "2024-08-01",
  },
  {
    id: 5,
    name: "Jane Smith",
    email: "jane@example.com",
    package: "intermediate",
    date: "2024-08-02",
  },
  {
    id: 6,
    name: "Sam Wilson",
    email: "sam@example.com",
    package: "vip",
    date: "2024-08-03",
  },
  {
    id: 7,
    name: "John Doe",
    email: "john@example.com",
    package: "basic",
    date: "2024-08-01",
  },
  {
    id: 8,
    name: "Jane Smith",
    email: "jane@example.com",
    package: "intermediate",
    date: "2024-08-02",
  },
  {
    id: 9,
    name: "Sam Wilson",
    email: "sam@example.com",
    package: "vip",
    date: "2024-08-03",
  },
  {
    id: 10,
    name: "John Doe",
    email: "john@example.com",
    package: "basic",
    date: "2024-08-01",
  },
  {
    id: 11,
    name: "Jane Smith",
    email: "jane@example.com",
    package: "intermediate",
    date: "2024-08-02",
  },
  {
    id: 12,
    name: "Sam Wilson",
    email: "sam@example.com",
    package: "vip",
    date: "2024-08-03",
  },
  {
    id: 13,
    name: "John Doe",
    email: "john@example.com",
    package: "basic",
    date: "2024-08-01",
  },
  {
    id: 14,
    name: "Jane Smith",
    email: "jane@example.com",
    package: "intermediate",
    date: "2024-08-02",
  },
  {
    id: 15,
    name: "Sam Wilson",
    email: "sam@example.com",
    package: "vip",
    date: "2024-08-03",
  },
  // Add more sample data as needed
];

export default bookingData;
